import React from "react";
import TableRow from "../../../../../Components/Common/TableRow";
import TableData from "../../../../../Components/Common/TableData";
import TableRowPerAction from "../../../../../Components/Common/TableRowPerAction";
import { convertToLocalDateTime } from "../../../../../utils/convertToLocalDateTime";
import { useAlert } from "../../../../../Context/AlertContext";
import useToastError from "../../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import { ExamInfoApiUrls } from "../../../../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth } from "../../../../../Api/swrConfig";
import { toast } from "react-toastify";

const stripHtml = (html) => html?.replace(/<[^>]+>/g, "") || "";

const FooterPageRow = ({ row, mutate, onEditClick }) => {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    ExamInfoApiUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete "${row.title}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger();
      }
    );
  };

  return (
    <TableRow key={row._id}>
      <TableData>{row.title}</TableData>
      <TableData>
        <span className="block w-40 truncate">{stripHtml(row.description)}</span>
      </TableData>
      <TableData>{row.slug}</TableData>
      <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
      <TableRowPerAction onEdit={() => onEditClick(row)} onDelete={handleDelete} />
    </TableRow>
  );
};

export default FooterPageRow;
